export function OutlinePaletteIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.0631 12.0221C20.1109 17.2269 15.136 20.9952 12.0811 21C11.5209 21 10.1227 21 9.08849 20.0041C8.94006 19.8604 8.15479 19.0991 8.09254 18.0074C7.97763 16.0346 10.41 15.1344 10.0892 14.0188C9.8163 13.0707 8.02551 13.5543 6.10065 12.0221C5.64098 11.6534 4.44393 10.6766 4.10396 9.02948C3.66824 6.91309 4.96105 5.21806 5.09991 5.0409C6.95774 2.68031 10.4436 2.98676 11.0852 3.04422C15.0642 3.39854 20.02 6.86042 20.0631 12.0221Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.09263 8.03291C8.64267 8.03291 9.08858 7.58701 9.08858 7.03696C9.08858 6.48692 8.64267 6.04102 8.09263 6.04102C7.54258 6.04102 7.09668 6.48692 7.09668 7.03696C7.09668 7.58701 7.54258 8.03291 8.09263 8.03291Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0819 9.029C13.6319 9.029 14.0778 8.5831 14.0778 8.03306C14.0778 7.48301 13.6319 7.03711 13.0819 7.03711C12.5318 7.03711 12.0859 7.48301 12.0859 8.03306C12.0859 8.5831 12.5318 9.029 13.0819 9.029Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0746 13.0173C16.6246 13.0173 17.0705 12.5714 17.0705 12.0213C17.0705 11.4713 16.6246 11.0254 16.0746 11.0254C15.5245 11.0254 15.0786 11.4713 15.0786 12.0213C15.0786 12.5714 15.5245 13.0173 16.0746 13.0173Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0819 18.0075C13.6319 18.0075 14.0778 17.5616 14.0778 17.0116C14.0778 16.4615 13.6319 16.0156 13.0819 16.0156C12.5318 16.0156 12.0859 16.4615 12.0859 17.0116C12.0859 17.5616 12.5318 18.0075 13.0819 18.0075Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
